import React from 'react'
import ReactDOM from 'react-dom/client'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'flag-icons/css/flag-icons.min.css';
import './index.css'
import App from './App'
import { PathContextProvider } from './context/path'
import { AuthContextProvider } from './context/auth'
import { UserContextProvider } from './context/user'
import { disableReactDevTools } from '@fvilers/disable-react-devtools'
import store from "./store";
import { Provider } from 'react-redux'
import { UnitContextProvider } from './context/unit'
import { FlightContextProvider } from './context/flight'
import { ConnectLogContextProvider } from './context/connectLog'
import { TargetContextProvider } from './context/target'
import { ReviewTargetContextProvider } from './context/reviewTarget'
import { VPNConnectLogContextProvider } from './context/vpnConnectLog'
import { FirstServerContextProvider } from './context/firstServer'
import { FirstServerIPsContextProvider } from './context/firstServerIPs'
import { MessageContextProvider } from './context/message';
import { ApplicationContextProvider } from './context/application';
import { ApplicationTypeContextProvider } from './context/appType';
import { CallProvider } from './context/call';

if (process.env.NODE_ENV === 'production') disableReactDevTools()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PathContextProvider>
        <AuthContextProvider>
          <UserContextProvider>
            <UnitContextProvider>
              <MessageContextProvider>
                <TargetContextProvider>
                  <ReviewTargetContextProvider>
                    <FlightContextProvider>
                      <ConnectLogContextProvider>
                        <VPNConnectLogContextProvider>
                          <FirstServerContextProvider>
                            <FirstServerIPsContextProvider>
                              <ApplicationContextProvider>
                                <ApplicationTypeContextProvider>
                                  <CallProvider>
                                    <App />
                                  </CallProvider>
                                </ApplicationTypeContextProvider>                                
                              </ApplicationContextProvider>
                            </FirstServerIPsContextProvider>
                          </FirstServerContextProvider>                        
                        </VPNConnectLogContextProvider>
                      </ConnectLogContextProvider>
                    </FlightContextProvider>
                  </ReviewTargetContextProvider>
                </TargetContextProvider>
              </MessageContextProvider>
            </UnitContextProvider>
          </UserContextProvider>
        </AuthContextProvider>
      </PathContextProvider>
    </Provider>
  </React.StrictMode>
)